


import { Box,Container } from "@mui/material";
const ParentWrapper = ({ children, sx }) => {



  return (
    <Box
      sx={{
        p: { xs: 1.5, sm: 2, md: 3 },
        boxSizing: "border-box",
        overflowX: "hidden",
        transition: (theme) =>
        theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest,
        }),
        backgroundColor: "#FEFEFE",
        minHeight: "100vh",
        gap: { xs: 2, md: 3 },
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      {children}
      
    </Box>
  );
};

export default ParentWrapper;



